import {getRouteApi} from "@tanstack/react-router";

export const representativeCommissionsRouteApi = getRouteApi(
  "/_app/sales/representatives/$representativeId/commissions/",
);
